/**
 * UUID v4 pure-JS. No requiere WebCrypto (no disponible en Hermes).
 * Suficiente para IDs locales que luego se sincronizan con el server.
 * Si en el futuro necesitamos entropia criptografica, migrar a expo-crypto
 * (Crypto.randomUUID) - eso si requiere rebuild del dev client.
 */
export function randomUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
